const tokenKey = (id: number) => `equipante-evento-token:${id}`;
const memoria = new Map<string, string>();

export function guardarTokenEquipanteEvento(id: number, token: unknown): void {
  if (!Number.isSafeInteger(id) || id <= 0 || typeof token !== "string" || !token) return;
  try { sessionStorage.setItem(tokenKey(id), token); } catch { memoria.set(tokenKey(id), token); }
}

export function obterTokenEquipanteEvento(id: number): string | undefined {
  if (!Number.isSafeInteger(id) || id <= 0) return undefined;
  const idDaUrl = typeof window !== "undefined"
    ? Number(window.location.pathname.match(/\/volunt(?:ario|ário)\/pagamento\/(\d+)\/?$/)?.[1])
    : 0;
  const token = idDaUrl === id ? new URLSearchParams(window.location.search).get("t") : null;
  if (token) {
    guardarTokenEquipanteEvento(id, token);
    return token;
  }
  try { return sessionStorage.getItem(tokenKey(id)) ?? undefined; } catch { return memoria.get(tokenKey(id)); }
}

/** Inclui a prova na chave RTK para separar a projeção mínima da resposta completa. */
export function checkoutEquipanteEventoQuery(id: number | null | undefined) {
  return { equipanteEventoId: Number(id) || 0, token: obterTokenEquipanteEvento(Number(id)) };
}

export function comTokenEquipanteEvento(path: string, id: number, token = obterTokenEquipanteEvento(id)): string {
  if (!token) return path;
  const [base, hash] = path.split("#");
  const [pathname, query] = base.split("?");
  const params = new URLSearchParams(query);
  params.set("t", token);
  return `${pathname}?${params.toString()}${hash ? `#${hash}` : ""}`;
}
